/**
 * JavaScript Utility - isNumeric
 * @author 서명환 <mhseo@ulalalab.com>
 */
function isNumeric(value) {
  value = Number(value);

  return !Number.isNaN(value) && Number.isFinite(value);
}

export default isNumeric;
